import React from "react";
import { Box, Typography } from "@mui/material";
import ProfilePicture from "bundles/common/components/ProfilePicture";
import { formatJobOfferLocations } from "bundles/common/utils/utils";

const SmallJobOfferCard = ({ offer, onClick }) => {
  return (
    <Box
      onClick={() => onClick && onClick(offer)}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "0.75rem",
        p: "0.75rem",
        borderRadius: "0.625rem",
        border: "1px solid hsl(214.3, 31.8%, 91.4%)",
        cursor: "pointer",
        transition: "all 0.2s ease",
        "&:hover": {
          borderColor: "hsla(145, 63%, 42%, 0.3)",
          boxShadow:
            "0 4px 8px -2px hsla(145, 63%, 42%, 0.08)",
        },
      }}
    >
      <Box sx={{ flexShrink: 0 }}>
        <ProfilePicture
          picture={offer?.company?.logo_url}
          picturesmall={offer?.company?.small_logo_url}
          size={32}
          initials={offer?.company?.name?.[0]}
          alt={`Logo ${offer?.company?.name}`}
        />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: "0.8125rem",
            fontFamily: "Segoe UI Semibold, system-ui, sans-serif",
            color: "hsl(222.2, 84%, 4.9%)",
            lineHeight: 1.3,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {offer?.job_title}
        </Typography>
        <Typography
          sx={{
            fontSize: "0.75rem",
            fontFamily: "Segoe UI Regular, system-ui, sans-serif",
            color: "hsl(215.4, 16.3%, 46.9%)",
            lineHeight: 1.3,
            mt: "0.125rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {formatJobOfferLocations(offer?.locations || []).join(" · ")}
        </Typography>
      </Box>
    </Box>
  );
};

export default SmallJobOfferCard;
